import css from 'styled-jsx/css';

const staticStyles = css`
  :global(.IBContractPageLayout) {
    margin-top: 0 !important;
  }

  :global(.IBContractPageLayout .PageLayout__header) {
    display: none !important;
  }

  .IBContract {
    max-width: 1080px;
    margin: 0 auto;
    padding: 40px 48px;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  }

  .IBContract__title {
    margin: 0 0 8px;
    color: #111827;
    font-size: 24px;
    font-weight: 600;
  }

  .IBContract__subtitle {
    margin: 0 0 24px;
    color: #6b7280;
    font-size: 15px;
    line-height: 1.5;
  }

  .IBContract__document {
    display: block;
    width: 100%;
    height: 760px;
    border: 1px solid #d1d5db;
    border-radius: 10px;
  }

  .IBContract__signature-section,
  .IBContract__wallet-section {
    margin-top: 24px;
    padding: 24px;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
  }

  .IBContract__section--error {
    border-color: #ef4444;
  }

  .IBContract__signature-section h2,
  .IBContract__wallet-section h2 {
    margin: 0 0 16px;
    color: #374151;
    font-size: 16px;
    font-weight: 600;
  }

  .IBContract__signature-section h2 span {
    color: #6b7280;
    font-size: 13px;
    font-weight: 400;
  }

  .IBContract__signature-pad {
    display: block;
    width: 100%;
    height: 240px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    background: #ffffff;
    cursor: crosshair;
    touch-action: none;
  }

  .IBContract__clear-button {
    display: block;
    margin: 12px 0 0 auto;
    padding: 0;
    border: 0;
    background: transparent;
    color: #7c3aed;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
  }

  .IBContract__wallet-section {
    display: grid;
    grid-template-columns: 260px 1fr;
    align-items: center;
    gap: 14px 20px;
  }

  .IBContract__wallet-section h2 {
    grid-column: 1 / -1;
  }

  .IBContract__wallet-section label {
    color: #374151;
    font-size: 14px;
  }

  .IBContract__wallet-section input,
  .IBContract__wallet-section select {
    width: 100%;
    box-sizing: border-box;
    padding: 11px 12px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    color: #1f2937;
    font-size: 14px;
  }

  .IBContract__actions {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    margin-top: 28px;
  }

  .IBContract__back-button,
  .IBContract__submit-button,
  .IBContract__modal button {
    min-width: 150px;
    padding: 12px 22px;
    border: 0;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  .IBContract__back-button {
    background: #f3f4f6;
    color: #374151;
  }

  .IBContract__submit-button,
  .IBContract__modal button {
    background: #4f46e5;
    color: #ffffff;
  }

  .IBContract__submit-button {
    margin-left: auto;
  }

  .IBContract__submit-button:disabled {
    cursor: wait;
    opacity: 0.6;
  }

  .IBContract__modal-backdrop {
    position: fixed;
    z-index: 1000;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(17, 24, 39, 0.45);
  }

  .IBContract__modal {
    width: 420px;
    max-width: calc(100% - 40px);
    padding: 26px;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 16px 50px rgba(0, 0, 0, 0.2);
  }

  .IBContract__modal h2 {
    margin: 0 0 12px;
    color: #111827;
    font-size: 18px;
  }

  .IBContract__modal p {
    margin: 0 0 20px;
    color: #4b5563;
    line-height: 1.5;
  }

  .IBContract__modal button {
    display: block;
    margin-left: auto;
    min-width: 80px;
  }

  @media (max-width: 768px) {
    .IBContract {
      padding: 24px 20px;
    }

    .IBContract__document {
      height: 560px;
    }

    .IBContract__wallet-section {
      grid-template-columns: 1fr;
    }

    .IBContract__wallet-section h2 {
      grid-column: auto;
    }
  }
`;

export { staticStyles };
